var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageTemplate',{attrs:{"title":"Playground"}},[_c('template',{slot:"header-buttons"},[_vm._v(" Test ")]),_c('template',{slot:"content"},[_vm._v(" Test ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }